/**
 * Mixin para las pantallas del conteo de inventario.
 *
 * Las mismas vistas se usan desde el contexto empresa (dueño, que elige la
 * sucursal por URL) y desde el POS (encargado, que opera siempre sobre la
 * sucursal de su sesión). Lo único que cambia entre contextos es a qué ruta
 * navegan y de dónde sale el uuid de la sucursal.
 *
 * Uso:
 *   import inventarioMixin from '@/mixins/inventario.mixin'
 *   mixins: [inventarioMixin]
 *
 *   $router.push({ name: rutaInventario('listado') })
 *   this.uuidSucursalInventario
 */

const RUTAS = {
  empresa: {
    stock: 'empresa.sucursal.productos.inventario',
    alertas: 'empresa.sucursal.alertas.stock',
    productoStock: 'empresa.sucursal.productos.item.inventario.stock',
    listado: 'empresa.sucursal.inventarios',
    listadoList: 'empresa.sucursal.inventarios.list',
    nuevo: 'empresa.sucursal.productos.inventario.nuevo',
    iniciado: 'empresa.sucursal.productos.inventario.iniciado',
    categoria: 'empresa.sucursal.productos.inventario.categoria',
    finalizar: 'empresa.sucursal.productos.inventario.finalizar',
    resumen: 'empresa.sucursal.productos.inventario.resumen',
  },
  pos: {
    stock: 'pos.productos.inventario',
    alertas: 'pos.alertas.stock',
    productoStock: 'pos.producto.detail.stock',
    listado: 'pos.inventarios',
    listadoList: 'pos.inventarios.list',
    nuevo: 'pos.inventarios.nuevo',
    iniciado: 'pos.inventarios.iniciado',
    categoria: 'pos.inventarios.categoria',
    finalizar: 'pos.inventarios.finalizar',
    resumen: 'pos.inventarios.resumen',
  },
};

export default {
  computed: {
    contextoInventario() {
      const contexto = this.$route.matched.find((r) => r.meta.context);
      return contexto && contexto.meta.context === 'pos' ? 'pos' : 'empresa';
    },

    // En empresa la sucursal viaja en la URL; en el POS es la de la sesión.
    uuidSucursalInventario() {
      const desdeRuta = this.$route.params.uuid_sucursal;
      if (desdeRuta) return desdeRuta;

      const sucursal = this.$store.state.sucursales.sucursal;
      return sucursal ? sucursal.uuid : null;
    },
  },

  methods: {
    rutaInventario(clave) {
      return RUTAS[this.contextoInventario][clave];
    },

    // Ficha de stock de un producto (psp). En empresa la sucursal viaja en la
    // URL; en el POS es la de la sesion y no forma parte de la ruta.
    locationProductoStock(pspId) {
      const params = { id_producto_sucursal: pspId };
      if (this.contextoInventario === 'empresa') {
        params.uuid_sucursal = this.uuidSucursalInventario;
      }
      return { name: this.rutaInventario('productoStock'), params };
    },
  },
};
